import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';

class Box extends Component {

    selectBox = () => {
        this.props.selectBox(this.props.row, this.props.col);
    }


    render() {
        return (
            <div 
                className={this.props.boxClass}
                id={this.props.id}
                onClick={this.selectBox}
            />
        )
    }
}

class Grid extends Component {
    render() {

        const width = this.props.cols * 16;
        var rowsArray = [];
        var boxClass = "";
        for(var i = 0; i < this.props.rows; i++) {
            for(var j = 0; j < this.props.cols; j++) {
                let boxId = i + "_" + j;
                boxClass = this.props.gridFull[i][j] ? "box on" : "box off";
                rowsArray.push(
                    <Box 
                        boxClass={boxClass}
                        key={boxId}
                        boxId={boxId}
                        row={i}
                        col={j}
                        selectBox={this.props.selectBox}
                    />
                )
            }
        }


        return (
            <div className="grid" style={{width: width}}>
                {rowsArray}
            </div>
        )
    }
}

class Buttons extends Component {
    render() {
        return (
            <div className="buttons">
                <a onClick={this.props.playToggleButton}>Play/Pause</a>
                <a onClick={this.props.slow}>Slower</a>
                <a onClick={this.props.fast}>Faster</a>
                <a onClick={this.props.clear}>Clear</a>
                <a onClick={this.props.seed}>Seed</a>
            </div>
        )
    }
}

class Main extends Component {

    constructor() {
        super();
        this.speed = 100;
        this.rows = 30;
        this.cols = 30;
        this.state = {
            generation: 0,
            gridFull: Array(this.rows).fill().map(() => Array(this.cols).fill(false)),
            playing: false
        }
    }

    selectBox = (row, col) => {
        let gridCopy = this.arrayClone(this.state.gridFull);
        gridCopy[row][col] = !gridCopy[row][col];
        this.setState({
            gridFull: gridCopy
        })
    }
    
    arrayClone = (array) => {
        return JSON.parse(JSON.stringify(array));
    }

    playToggleButton = () => {
        if(this.state.playing) {
            this.setState({
                playing: false,
                playingText: "Play"
            }, () => {
                console.log(this.state.playingText);
                clearInterval(this.intervalId);
            });
        } else {
            this.setState({
                playing: true,
                playingText: "Pause"
            }, () => {
                console.log(this.state.playingText);
                clearInterval(this.intervalId);
                this.intervalId = setInterval(this.play, this.speed);
            });
        }
    }

    playButton = () => {
        this.setState({
            playing: true,
            playingText: "Pause"
        }, () => {
            console.log(this.state.playingText);
            clearInterval(this.intervalId);
            this.intervalId = setInterval(this.play, this.speed);
        });
    }

    slow = () => {
        this.speed += 50;
        this.playButton();
    }

    fast = () => {
        this.speed -= 50;
        this.playButton();
    }

    clear = () => {
        var grid = Array(this.rows).fill().map(() => Array(this.cols).fill(false));
        this.setState({
            gridFull: grid,
            generation: 0
        })
    }


    // Game of life rules
    play = () => {
        let g = this.state.gridFull;
        let g2 = this.arrayClone(this.state.gridFull);

        for (let i = 0; i < this.rows; i++) {
            for (let j = 0; j < this.cols; j++) {
                let count = 0;
                if (i > 0) if (g[i - 1][j]) count++;
                if (i > 0 && j > 0) if(g[i - 1][j - 1]) count++;
                if (i > 0 && j < this.cols - 1) if (g[i - 1][j + 1]) count++;
                if (j < this.cols - 1) if (g[i][j + 1]) count++;
                if (i > 0) if(g[i][j - 1]) count++;
                if (i < this.rows - 1) if (g[i + 1][j]) count++;
                if (i < this.rows - 1 && j > 0) if (g[i + 1][j - 1]) count++;
                if (i < this.rows - 1 && this.cols - 1) if (g[i + 1][j + 1]) count++;
                if (g[i][j] && (count < 2 || count > 3)) g2[i][j] = false;
                if (!g[i][j] && count === 3) g2[i][j] = true; 
            }
        }
        this.setState({
            gridFull: g2,
            generation: this.state.generation + 1
        });
    }

    seed = () => {
        let gridCopy = this.arrayClone(this.state.gridFull);
        for (let i = 0; i < this.rows; i++) {
            for (let j = 0; j < this.cols; j++) {
                if (Math.floor(Math.random() * 4) === 1) {
                    gridCopy[i][j] = true;
                }
            }
        }
        this.setState({
            gridFull: gridCopy
        })
    }

    componentDidMount() {
        this.seed();
        this.playButton();
    }

    render() {
        return (
            <div className="main">
                <Buttons
                    playToggleButton={this.playToggleButton}
                    slow={this.slow}
                    fast={this.fast}
                    clear={this.clear}
                    seed={this.seed}
                    gridSize={this.gridSize}
                />
                <Grid
                gridFull={this.state.gridFull}
                rows={this.rows}
                cols={this.cols}
                selectBox={this.selectBox}
                />
                <h4>gen{this.state.generation}</h4>
            </div>
        )
    }

}

ReactDOM.render(<Main/>, document.getElementById('root'));
